/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, Divider, TextField, Button, Grid } from '@material-ui/core'
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';


import Actions from '../../../fluid/Actions/ActionFactory'

const clone = require('rfdc')()

const styles = theme => ({
    formControl: {
        margin: theme.spacing(3),
    },
    label : {
        overflowWrap : 'break-word',
        // wordWrap : 'break-word'
    }
})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: '#dc004e',
        },
      },
})

class FieldsInScope extends Component {
    state = {
        fields : [],
        fields_received : false,
        error : false,
        error_message : null,
        submit_load : false
    }

    componentDidMount () {
        const headingHeight = this.heading.current.clientHeight
        const footerHeight = this.footer.current.clientHeight
        const contentHeight = this.props.maxHeight - headingHeight - footerHeight
        this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight}, () => {
            Actions('http_request', {
                url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/fields_schema',
                method: 'get',
                data: {}
            }).then(res => {
                let fields = res.data.result
                fields.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (b.name > a.name) {
                        return -1;
                    }
                    return 0;
                })
                this.setState({
                    ...this.state, 
                    fields : this.addCheckedState(fields),
                    fields_received : true
                })
            }).catch(err => {
                this.setState({...this.state, error : true, error_message : "There are no fields available for this IU.", fields_received : true, fields : []})
            })
        })
    }

    componentDidUpdate (prevProps, prevState) {
        console.log('Did Update')
        if (prevProps.maxHeight === null && this.props.maxHeight !== null) {
            const headingHeight = this.heading.current.clientHeight
            const footerHeight = this.footer.current.clientHeight
            const contentHeight = this.props.maxHeight - headingHeight - footerHeight
            console.log('Max Height IU: ', this.props.maxHeight)
            console.log('Head Height :', headingHeight)
            console.log('Content Height IU :', contentHeight)
            this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight})
        }
    }

    heading = React.createRef()
    footer = React.createRef()

    addCheckedState = (fields) => {
        fields.map(field => {
            field.checked = false
        })

        return fields
    }

    submitFields = () => {
        let fields_in_scope = []

        this.state.fields.forEach(field => {
            if (field.checked) {
                if (field.checked === true) {
                    let new_field = {}
                    new_field.name = field.name
                    new_field.type = field.type
                    new_field.value = field.value

                    fields_in_scope.push(new_field)
                }
            }
        })

        if(fields_in_scope.length > 0 ){
            this.setState({
                ...this.state,
                submit_load : true,
                error : false
            }, () => {
                Actions('http_request', {
                    url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/field_in_scope',
                    method: 'post',
                    data : fields_in_scope
                }).then(res => {
                    this.setState({...this.state, submit_load : false}, () => {
                        this.props.handleNext()
                    })
                }).catch(err => {
                    this.setState({...this.state, submit_load : false, error : true, error_message : err.response.data.message})
                })
            })
        } else {
            this.setState({...this.state, error : true, error_message : "Select at least 1 field."})
        }
        
    }

    getSelectAllState = () => {
        let num_selected = this.state.fields.filter(field => field.checked === true).length - 1

        if (num_selected === this.state.fields.length - 1) {
            return true
        } else {
            return false
        }
    }

    selectAll = () => {
        let fields = this.state.fields
        if (this.getSelectAllState() === true) {
            fields.forEach(field => {
                field.checked = false
            })
            this.setState({fields : fields})
        } else {
            fields.forEach(field => {
                field.checked = true
            })
            this.setState({fields : fields})
        }
    }

    renderList = () => {
        if (this.state.fields_received === false) {
            return (
                <div style = {{width : '100%', height : '100%', display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress color = 'primary'/>
                </div>
            )
        } else {
            return (
                <Fragment>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', padding : '8px'}}>
                        {this.renderListItems()}
                    </div>
                </Fragment>
            )
        }
    }

    renderListItems = () => {
        const { classes } = this.props
        if (this.state.fields.length > 0) {
            let list = this.state.fields.map(field => {
                return (
                    <Paper 
                        variant = 'outlined' 
                        style = {{padding : '5px', paddingLeft: '10px', width : '19%', marginRight : '1%', marginTop : '1%', overflowWrap : 'break-word'}}>
                        <FormControl component="fieldset" >
                            <FormControlLabel
                                style = {{width : '100%'}}
                                classes={{ // class name, e.g. `classes-nesting-root-x`
                                    label: classes.label, // class name, e.g. `classes-nesting-label-x`
                                }}
                                control={<Checkbox size = 'small' checked={field.checked} onChange={this.handleChange} name={field.name} color = 'secondary'/>}
                                label={field.name}
                            />
                        </FormControl>
                    </Paper>
                )
            })

            return list
        } else {
            return (
                <div style = {{width : '100%', height : this.state.content_height, display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography style = {{color : '#f44336', }} variant = 'caption'>
                        There are no fields available for this IU.
                    </Typography>
                </div>
            )
        }

    }

    handleChange = (event) => {
        let new_state = clone(this.state)

        let fields = new_state.fields

        fields.forEach(field => {
            if (field.name === event.target.name) {
                field.checked = field.checked ? !field.checked : true
            }
        })

        this.setState({...new_state, error: false}, () => console.log('Transfer list state :', this.state))
    }

    render() {
        const { classes } = this.props
        return (
            <Paper elevation = {0} square style = {{width : '100%', height : '100%'}}>
                <div style = {{width : '100%', height : '100%'}}>
                    <div ref = {this.heading} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row', 
                           // alignItems : 'flex-end',
                            backgroundColor : '#F0F0F0',
                            alignItems : 'center',
                            borderBottom : '1px solid rgba(0,0,0,0.12)',
                            padding : '8px'
                        }}
                    >
                        <div style = {{flexGrow : 1}}>
                            <Typography variant='h6'>Fields In Scope</Typography>
                            <Typography variant = 'caption'>Select temporal field along with the required fields here.</Typography>
                        </div>
                        {
                            this.state.error === true ? <Typography style = {{color : '#f44336', marginRight: '10px'}} variant = 'caption'>
                                {this.state.error_message}
                            </Typography> : null
                        }
                        <FormControl component="fieldset" style={{ alignSelf: "flex-end"}}>
                            <FormControlLabel
                                style = {{width : '100%'}}
                                control={<Checkbox 
                                            size = 'small' 
                                            checked = {this.getSelectAllState()}  
                                            onChange={this.selectAll} 
                                            name = "select-all" 
                                            color = 'secondary'
                                        />}
                                label= "Select All"
                            />
                        </FormControl>
                    </div>
                    <div 
                        style = {{
                            width : '100%',
                            height: this.state.content_height, 
                            overflow: 'scroll',
                        }}
                    >
                        <ThemeProvider theme = {blue_theme}>
                            {this.renderList()}
                        </ThemeProvider>
                    </div>
                    <div ref = {this.footer} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row-reverse',
                            backgroundColor : '#F0F0F0',
                            padding : '8px',
                            borderTop : '1px solid rgba(0,0,0,0.12)',
                        }}>
                        <ThemeProvider theme = {blue_theme}>
                            <Button
                                variant = 'contained'
                                color = 'primary'
                                size = 'small'
                                onClick = {this.submitFields}
                                startIcon = {this.state.submit_load ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                            >
                                {this.state.fields.length > 0 ? 'Submit' : 'Next'}
                            </Button>
                        </ThemeProvider>
                    </div>
                </div>
            </Paper>
        );
    }
}

export default withStyles(styles)(FieldsInScope);